import type React from 'react';

import { formatDateBy } from '~/utils/dateTime';
import { Text } from '@shopify/polaris';
import { useMemo } from 'react';

export interface StartTimePropertyProps {
  startedAt?: string;
}

export const StartTimeProperty: React.FC<StartTimePropertyProps> = ({ startedAt }) => {
  const startTime = useMemo(
    () => (startedAt ? formatDateBy('MMM DD YYYY', startedAt) : '-'),
    [startedAt],
  );

  return (
    <Text as="p" variant="bodyMd" alignment="center" fontWeight="medium" tone="subdued">
      {startTime}
    </Text>
  );
};
